import { GetQuoteResponse } from '../../../shared/interfaces/getQuote.interface';
import { BookingQuoteResponse } from './bookingQuoteResponse.interface';

// @TODO - IMPORTANT - This function is not properly implement, it should store last quote in the context and update it with new quote.
const mapToCreateQuoteResponse = (
  quoteId: string,
  policyId: string,
  quoteResult: GetQuoteResponse,
  accessToken: string | null,
): BookingQuoteResponse => {
  const quoteDetail = {
    quoteId,
    policyId,
    quotationStep: quoteResult.quote.quotationStep,
    product: {
      price: {
        currency: quoteResult.quote?.product.price.currency,
        tax: quoteResult.quote.product.price.tax,
        grossPremium: quoteResult.quote.product.price.grossPremium,
        netPrice: quoteResult.quote.product.price.netPrice,
        commission: 0, //! @TODO - currently not supported and hardcoded to 0. To fix if it will be supported.
        promotion: quoteResult.quote.product.price.promotion,
        grossPremiumBeforePromotion:
          quoteResult.quote.product.price.grossPremiumBeforePromotion,
      },
      code: quoteResult.quote.product.code,
    },
    genericData: quoteResult.quote.genericData,
    creationDate: quoteResult.quote.creationDate,
    expirationDate: quoteResult.quote.expirationDate,
  };

  return {
    requestId: quoteResult.requestId,
    // @TODO here should be full quote!
    quotes: [quoteDetail],
    quote: quoteResult.quote,
    insurance: quoteResult.insurance,
    accessToken: accessToken || '',
  };
};

export default mapToCreateQuoteResponse;
